import React from "react";
import PropTypes from "prop-types";
import Tab from "~/components/MatchingPage/ResultsTabBar/Tab";
import TabBar from "~/components/TabBar";

export default class ResultsTabBar extends React.PureComponent {
    static propTypes = {
        configuration: PropTypes.object.isRequired,
        state: PropTypes.object.isRequired,
        activeIndexName: PropTypes.string.isRequired,
        onActiveIndexNameChange: PropTypes.func.isRequired,
    };

    render() {
        const {configuration, state, activeIndexName} = this.props;

        return (
            <TabBar>
                {configuration.indices.map((index, key) => {
                    return (
                        <Tab
                            key={key}
                            index={index}
                            state={state.results[index.name]}
                            isActive={index.name === activeIndexName}
                            onClick={this.handleTabClick}
                        />
                    );
                })}
            </TabBar>
        );
    }

    handleTabClick = index => {
        this.props.onActiveIndexNameChange(index.name);
    };
}
